import { Link } from "react-router-dom";
import React, { useContext, useEffect, useState, useRef } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { Button, IconButton } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import DispatchContext from "../DispatchContext";
import LoginDialog from "./LoginDialog";
import SignUpDialog from "./SignUpModal";
import StateContext from "../StateContext";
import PersonIcon from "@mui/icons-material/Person";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LoginModal from "./loginModal/loginModal";
import kuwaitFlag from "../Assets/images/kuwaitinput.png"
import { withTranslation, useTranslation, Trans } from "react-i18next";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import QRCodeStyling from "qr-code-styling";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';
import ShareIcon from '@mui/icons-material/Share';
import { RWebShare } from "react-web-share";
import { erase, setCookie } from "../Functions/cookieFunction";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const qrCode = new QRCodeStyling({
  width: 200,
  height: 200,

  dotsOptions: {
    color: "#eb5b5e",
    type: "dot"
  },
  imageOptions: {
    crossOrigin: "anonymous",
    margin: 20
  }
});

const MiscBanner = ({ children, cover }) => {
  // const appDispatch = useContext(DispatchContext);
  const [url, setUrl] = useState("");
  const [fileExt, setFileExt] = useState("png");
  const ref = useRef(null);
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });
  const [openQrCode, setOpenQrCode] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    appDispatch({ type: "setLoginModal", loginModal: false });
  };

  const [openLogin, setOpenLogin] = useState(false);
  const [openSignUp, setOpenSignUp] = useState(false);
  const handleClickOpenLogin = () => {
    // appDispatch({ type: "setLoginModal", loginModal: true });
    var shop_url = window.location.href
    var auth_url = `${process.env.REACT_APP_AUTH_URL}`
    setCookie(`redirect`, shop_url);
    window.location.replace(auth_url);
  };
  const handleClickOpenSignUp = () => {
    // appDispatch({ type: "setSignUpPhoneModal", signUpPhoneModal: true });
    var shop_url = window.location.href
    var auth_url = `${process.env.REACT_APP_AUTH_URL}`
    setCookie(`redirect`, shop_url);
    window.location.replace(auth_url);
  };
  const handleCloseLogin = () => {
    setOpenLogin(false);
  };

  const handleLogout = () => {

    erase("tokenAuth");
    erase("Profile");
    appDispatch({ type: "logout" });
    setAlertMessage({ open: true, message: "Logout !", alertSuccess: true });
    setLoading(false);
  };

  // localization  start

  const arLanguageHandle = (e) => {
    // // console.log("ar change");
    appDispatch({
      type: "LangChange",
      langValue: "ar",
    });
    //   i18n.changeLanguage('ar')
  };
  const enLanguageHandle = (e) => {
    // // console.log("en change");

    appDispatch({
      type: "LangChange",
      langValue: "en",
    });
  };



  const handleClickOpenQrCode = () => {

    appDispatch({
      type: "setShareInvoiceQrcode",
      shareInvoiceQrcode: true,
    });
  };





  return (
    <div className={`storeBanner classForQrcodeStyling ${appState.langValue === "ar" ? "directionRtl" : ""}`}>
      {/* <SignUpDialog
        open={open}
        handleClickOpen={handleClickOpen}
        handleClose={handleClose}
      />
      <LoginDialog
        open={openLogin}
        handleLoginOpen={handleClickOpenLogin}
        handleClose={handleCloseLogin}
      /> */}

      <LoginModal closeBtn={true} backDrop={false} />


      <img
        src={cover ? `${cover}` : `${process.env.REACT_APP_IMAGE_URL}image.jpg`}
        className="img-fluid store-img"
        alt="img"
      />

      <div className="top_nav_bar_payment">
        <div className="row m-0 searhIcon">
          <div>
            <h6 className="mb-0">  {t("invoice.invoice")}</h6>
          </div>

          {!appState.loggedIn ? (
            <div className="d-flex align-items-center ">
              {appState.langValue == "ar" ? <Button
                onClick={(e) => enLanguageHandle(e)}
                variant="contained"
                className="signUpBtn mx-md-2 mx-1"
              >
                <span className="px-2">En</span>

              </Button> : <Button
                onClick={(e) => arLanguageHandle(e)}
                variant="contained"
                className="signUpBtn  mx-0"
              >
                <span className="familyGraphikArabic mb-2">عربي</span>

              </Button>}
              <Button
                onClick={handleClickOpenQrCode}
                variant="contained"
                className="signInBtnNew mx-md-2 mx-1 "
              >
                <ShareIcon />
                {t("invoice.share")}

              </Button>
              <Button
                onClick={handleClickOpenSignUp}
                variant="contained"
                className="signInBtnNew mx-md-2 mx-1"
              >
                <PersonIcon />
                {t("login.Login")}

              </Button>



            </div>
          ) : (
            <div className="signout-btn align-items-center">
              <span> {appState.langValue == "ar" ? <Button
                onClick={(e) => enLanguageHandle(e)}
                variant="contained"
                className="signUpBtn mx-md-2 mx-1"
              >
                <span className="px-2">En</span>

              </Button> : <Button
                onClick={(e) => arLanguageHandle(e)}
                variant="contained"
                className="signUpBtn "
              >
                <span className="familyGraphikArabic mb-2">عربي</span>

              </Button>}</span>
              <span>  <Button
                onClick={handleClickOpenQrCode}
                variant="contained"
                className="signInBtnNew mx-md-2 mx-1 "
              >

                <ShareIcon />
                {t("invoice.share")}

              </Button></span>
              <span>
                <Button

                  variant="contained"
                  className="signInBtn px-1"
                  onClick={handleLogout}
                >
                  <PersonIcon />
                  {t("invoice.logout")}
                </Button>
              </span>

            </div>
          )}
        </div>
      </div>

      {children && children}

      {/* {false ? <MiscBanner cover={store.cover}>
        <div className="container">
          <section id="info" className="infoCard">
            <div className="row m-0 py-2 align-items-center">
              <div className="logoImg">
                <img
                  src={
                    store.logo
                      ? `${store.logo}`
                      : `${process.env.REACT_APP_IMAGE_URL}brandLogo.png`
                  }
                  className="img-fluid"
                  width="55"
                  alt=""
                />
              </div>
              <div
                className={`infoContent px-3  ${appState.langValue === "ar"
                  ? "d-flex flex-column align-items-start "
                  : ""
                  }`}
              >
                <h5 className="mb-1">
                  {store.business_desc
                    ? type === "in"
                      ? store.business_desc.en
                      : store.business_desc.en
                    : "Car Wash"}
                </h5>

                <h4 className="mb-1">
                  {type === "in"
                    ? store.business_name
                    : store.business_name}
                </h4>

                <p className="m-0">
                  {store.address ? store.address : ""}
                </p>
              </div>
              <div
                className={`infoIcon  mb-5 ${appState.langValue === "ar"
                  ? "mr-auto"
                  : "ml-auto"
                  }`}
              >
                <CheckCircleIcon className="CheckCircleIcon" />
              </div>
            </div>

            <div className={`am_loggedIn`}>
              <div className="row m-0 align-items-center">
                <p
                  className={`col m-0  ${appState.langValue === "ar"
                    ? "text-right"
                    : "text-left"
                    }`}
                >
                  <strong>{t("invoice.Amount")}</strong>
                </p>
                <div className="col d-flex justify-content-end align-items-center">
                  {type === "in" &&
                    invoiceDetails.status !== "Partial" ? (
                    <p className=" px-3 m-0 text-center">
                      {amount}
                    </p>
                  ) : (
                    <input

                      onChange={(e) => handleAmount(e)}
                      className="px-3 qpInputField"
                      value={
                        type === "in"
                          ? amount
                          : invoiceDetails.amount
                      }
                      type="number"
                      placeholder="0"
                    />
                  )}

                  <p className=" px-0 m-0 text-right">{t("KWD")}</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </MiscBanner> : ""} */}
    </div>
  );
};
const styles = {
  inputWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  inputBox: {
    width: "100%",
    margin: "0px"

  }
};
export default withTranslation()(MiscBanner);

